import React, { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import CryptoJS from "crypto-js";
// images
import chatbackgroundImg from "../../../Assets/images/chat/ChatBackground.png";
import nochatImg from "../../../Assets/images/svg/nochat.svg";
import NoSelectContact from "../../../Assets/images/svg/No-interactions.svg";
// mui
import { Box, Stack, Typography } from "@mui/material";
// chat style
import "../../../Assets/style/components/audiochat.scss";
// import "./Chat-Style/chat.css";
import moment from "moment";
import { connect } from "react-redux";
import { toaststyle } from "../../../Utils/toaststyle";
import {
  setcontactlist,
  setCustomerTyping,
  setArrivalMessage,
  setChatSpinner,
  setChatSessionId,
  updateNotification,
  updateAgentList,
  updateContactList,
  setMsgTone2,
  setEmailList,
  setShowEmailList,
  setselectedMail,
  fetchEmail,
  setMessage,
  translateSingleMessage,
} from "../../../Redux/Actions/actions";
import { toast } from "react-toastify";
import {
  BaseUrl,
  emailservice,
  SocketUrl,
} from "../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
// components
import InternalConversationHeader from "./InternalChatComponent/Internal-Header-component";
import ConversationBodyInternal from "./InternalChatComponent/Conversation-Body-Component-Internal";
import CoversationFooterInternal from "./InternalChatComponent/Conversation-Footer-component-Internal";
import EmailConversationHeader from "./ExternalChatComponent/HeaderComponent/Email-Header-component";
import VoiceConversationHeader from "./ExternalChatComponent/HeaderComponent/Voice-Header-component";
import VideoChatConversationHeader from "./ExternalChatComponent/HeaderComponent/VideoChat-Header-component";
import WebChatConversationHeader from "./ExternalChatComponent/HeaderComponent/WebChat-Header-component";
import ConversationBodyExternal from "./ExternalChatComponent/Conversation-Body-Component-External";
import CoversationFooterExternal from "./ExternalChatComponent/Conversation-Footer-component-External";
import EmailBody from "./EmailBodyComponent/EmailBody";
import UserListComponent from "../User-list-component/User-list.component";
import UserListComponent2 from "../User-list-component/User-list2.component";
import SendMailComponent from "./EmailBodyComponent/EmailTypes/SendMailComponent";

const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    contactList: contactListData.contactList,
    selectedchanneldata: data.selectedchanneldata,
    userlistshow: data.userlistshow,
    value: data.value,
    index: contactListData.index,
    index2: contactListData.index2,
    selectedExternalChatType: contactListData.selectedExternalChatType,
    arrivalMessage: contactListData.arrivalMessage,
    internalChatData: contactListData.internalChatData,
    externalChatData: contactListData.externalChatData,
    chatSessionId: contactListData.chatSessionId,
    agentList: data.agentList,
    mailList: state.email.mailList,
    showEmailList: state.email.showEmailList,
    selectedMail: state.email.selectedMail,
    mailType: state.email.mailType,
    customerTyping: state.data.customerTyping,
    message: state.chatReducer.message,
    translationLanguage: state.chatReducer.translationLanguage,
    fromLanguage: state.chatReducer.fromLanguage,
    showChatFullScreen: state.chatReducer.showChatFullScreen,

  };
};
const socket = io(SocketUrl + `/${localStorage.getItem("TenantId")}`);
const ChatComponent = (props) => {
  const {
    value,
    playMsgTone,
    callObj2,
    callmap,
    stopwatch1,
    stopwatch2,
    aesSocket,
  } = props;
  const datas = JSON.parse(localStorage.getItem("tokenAgent"));
  let selectedChat = JSON.parse(localStorage.getItem("client"));
  const [expanded, setExpanded] = useState();
  const conversationBodyRef = useRef(null);
  const contentRef = useRef();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  function insertAndShift(arr, from, to) {
    let cutOut = arr.splice(from, 1)[0];
    arr.splice(to, 0, cutOut);
    return arr;
  }
  const handleTyping = async () => {
    try {
      const data = await JSON.parse(localStorage.getItem("tokenAgent"));
      if ((selectedChat ? selectedChat.chat_type : "") == "internal") {
        let sender_id = props.internalChatData
          ? props.internalChatData.senderDetails[0]._id
          : "";
        let current_agent_id = data.id;

        if (sender_id == current_agent_id) {
          socket.emit("typing-send-msg", {
            to: props.internalChatData ? props.internalChatData.id : "",
            from: data.id,
            senderName: data.username,
            chatType: "outbound",
            chatdetails: props.internalChatData ? props.internalChatData : "",
          });
        } else {
          socket.emit("typing-send-msg", {
            to: props.internalChatData ? props.internalChatData.agent : "",
            from: data.id,
            senderName: data.username,
            chatType: "inbound",
            chatdetails: props.internalChatData ? props.internalChatData : "",
          });
        }
      } else {
        socket.emit("typing-send-msg", {
          to: selectedChat ? selectedChat.id : "",
          from: data.id,
          senderName: data.username,
          chatType: "outbound",
          chatdetails: selectedChat,
        });
      }
    } catch (error) {
      console.log("handleTyping", error);
    }
  };
  const handleSendMsg = async (msg, msg_type, fileNameForDoc) => {
    try {
      const data = await JSON.parse(localStorage.getItem("tokenAgent"));
      if ((selectedChat ? selectedChat.chat_type : "") == "internal") {
        var newcontactlist1 = [];
        var i = 0;
        var find = 0;
        // const encryptedMessage = CryptoJS.AES.encrypt(
        //   msg,
        //   "your-secret-key"
        // ).toString();

        JSON.parse(localStorage.getItem("agentList")).map((client1) => {
          if ((selectedChat ? selectedChat.id : "") == client1.id) {
            find = i;
            client1.lastmessage = msg;
            client1.lastmessagetime = moment().format("h:mm A");
            client1.currentChat = client1.id == msg.from ? true : false;
            client1.unreadcount = 0;
          }
          newcontactlist1.push(client1);
          i++;
        });

        let newagent = insertAndShift(newcontactlist1, find, 0);
        props.updateAgentList(newagent);

        let sender_id = props.internalChatData
          ? props.internalChatData.senderDetails[0]._id
          : "";
        let current_agent_id = data.id;
        if (sender_id == current_agent_id) {
          await axios.post(
            BaseUrl + "/message/addMessage",
            {
              from: data.id,
              to: props.internalChatData ? props.internalChatData.id : "",
              message: msg,
              senderName: data.username,
              receiverName: props.internalChatData
                ? props.internalChatData.username
                : "",
              messageFrom: "fromAgent",
              userType: props.internalChatData
                ? props.internalChatData.chat_type
                : "",
              session: props.internalChatData
                ? props.internalChatData.chat_session_id
                : "",
              msg_sent_type: msg_type,
              chatdetails: props.internalChatData ? props.internalChatData : "",
              file_name: fileNameForDoc,
              captions: "",
            },
            {
              headers: {
                tenantId: localStorage.getItem("TenantId"),
              },
            }
          );

          socket.emit("send-msg", {
            to: props.internalChatData ? props.internalChatData.id : "",
            session_id: props.internalChatData
              ? props.internalChatData.chat_session_id
              : "",
            from: data.id,
            senderName: data.username,
            chatType: "outbound",
            msg: msg,
            msgType: "web",
            userType: props.internalChatData
              ? props.internalChatData.chat_type
              : "",
            msg_sent_type: msg_type,
            chatdetails: props.internalChatData ? props.internalChatData : "",
            file_name: fileNameForDoc,
            captions: "",
          });

          socket.emit("last-msg-send", {
            to: props.internalChatData ? props.internalChatData.id : "",
            from: data.id,
            chatType: "outbound",
            msg,
            senderName: data.username,
            userType: props.internalChatData
              ? props.internalChatData.chat_type
              : "",
            chatdetails: props.internalChatData ? props.internalChatData : "",
            file_name: fileNameForDoc,
            captions: "",
          });
          const msgs = [...props.message];
          let newMessage = {
            fromSelf: true,
            message: msg,
            session_id: props.internalChatData
              ? props.internalChatData.chat_session_id
              : "",
            senderName: data.username,
            receiverName: props.internalChatData
              ? props.internalChatData.username
              : "",
            to: props.internalChatData ? props.internalChatData.id : "",
            sender: data.id,
            time: moment().format("lll"),
            msg_sent_type: msg_type,
            file_name: fileNameForDoc,
            captions: "",
          };

          // Translate if translation is active
          if (props.translationLanguage) {
            newMessage = await translateSingleMessage(
              newMessage,
              props.fromLanguage,
              props.translationLanguage
            );
          }

          msgs.push(newMessage);
          props.setMessage(msgs);
          playMsgTone();
        } else {
          await axios.post(
            BaseUrl + "/message/addMessage",
            {
              from: data.id,
              to: props.internalChatData ? props.internalChatData.id : "",
              message: msg,
              senderName: data.username,
              receiverName: props.internalChatData
                ? props.internalChatData.username
                : "",
              messageFrom: "fromAgent",
              userType: props.internalChatData
                ? props.internalChatData.chat_type
                : "",
              session: props.internalChatData
                ? props.internalChatData.chat_session_id
                : "",
              msg_sent_type: msg_type,
              chatdetails: props.internalChatData ? props.internalChatData : "",
              file_name: fileNameForDoc,
              captions: "",
            },
            {
              headers: {
                tenantId: localStorage.getItem("TenantId"),
              },
            }
          );

          socket.emit("send-msg", {
            to: props.internalChatData ? props.internalChatData.agent : "",
            session_id: props.internalChatData
              ? props.internalChatData.chat_session_id
              : "",
            from: props.internalChatData ? props.internalChatData.id : "",
            senderName: data.username,
            chatType: "inbound",
            msg: msg,
            msgType: "web",
            userType: props.internalChatData
              ? props.internalChatData.chat_type
              : "",
            msg_sent_type: msg_type,
            chatdetails: props.internalChatData ? props.internalChatData : "",
            file_name: fileNameForDoc,
            captions: "",
          });

          socket.emit("last-msg-send", {
            to: props.internalChatData ? props.internalChatData.agent : "",
            from: props.internalChatData ? props.internalChatData.id : "",
            chatType: "inbound",
            msg,
            senderName: data.username,
            userType: props.internalChatData
              ? props.internalChatData.chat_type
              : "",
            chatdetails: props.internalChatData ? props.internalChatData : "",
          });

          const msgs = [...props.message];
          let newMessage2 = {
            fromSelf: true,
            message: msg,
            session_id: props.internalChatData
              ? props.internalChatData.chat_session_id
              : "",
            senderName: data.username,
            receiverName: props.internalChatData
              ? props.internalChatData.username
              : "",
            to: props.internalChatData ? props.internalChatData.id : "",
            sender: data.id,
            time: moment().format("lll"),
            msg_sent_type: msg_type,
            file_name: fileNameForDoc,
            captions: "",
          };

          // Translate if translation is active
          if (props.translationLanguage) {
            newMessage2 = await translateSingleMessage(
              newMessage2,
              props.fromLanguage,
              props.translationLanguage
            );
          }

          msgs.push(newMessage2);
          props.setMessage(msgs);
          playMsgTone();
        }
      } else {
        var newcontactlist = [];
        var i = 0;
        var find = 0;
        // const encryptedMessage = CryptoJS.AES.encrypt(
        //   msg,
        //   "your-secret-key"
        // ).toString();
        JSON.parse(localStorage.getItem("contactList")).map((client) => {
          if ((selectedChat ? selectedChat.id : "") == client.id) {
            find = i;
            client.lastmessage = msg;
            client.lastmessagetime = moment().format("h:mm A");
            client.lastmessageUpdatedat = moment();
            client.currentChat = client.id == msg.from ? true : false;
            client.unreadcount = 0;
          }
          newcontactlist.push(client);
          i++;
        });
        let newexternalcontact = insertAndShift(newcontactlist, find, 0);
        props.updateContactList(newexternalcontact);

        axios
          .post(
            BaseUrl + "/message/addMessage",
            {
              from: data.id,
              to: props.externalChatData ? props.externalChatData.id : "",
              message: msg,
              senderName: data.username,
              receiverName: props.externalChatData
                ? props.externalChatData.username
                : "",
              messageFrom: "fromAgent",
              userType: props.externalChatData
                ? props.externalChatData.chat_type
                : "",
              session: props.externalChatData
                ? props.externalChatData.chat_session_id
                : "",
              msg_sent_type: msg_type,
              file_name: fileNameForDoc,
              chatdetails: props.externalChatData ? props.externalChatData : "",
              captions: "",
            },
            {
              headers: {
                tenantId: localStorage.getItem("TenantId"),
              },
            }
          )
          .then((res) => {})
          .catch((err) => {});

        socket.emit("send-msg", {
          to: props.externalChatData ? props.externalChatData.id : "",
          from: data.id,
          session_id: props.externalChatData
            ? props.externalChatData.chat_session_id
            : "",
          senderName: data.username,
          chatType: "outbound",
          msg: msg,
          msgType: "web",
          userType: props.externalChatData
            ? props.externalChatData.chat_type
            : "",
          msg_sent_type: msg_type,
          chatdetails: props.externalChatData ? props.externalChatData : "",
          file_name: fileNameForDoc,
          captions: "",
          time: moment().format("MMM DD, YYYY h:mm A"),
        });
        socket.emit("last-msg-send", {
          to: props.externalChatData ? props.externalChatData.id : "",
          from: data.id,
          chatType: "outbound",
          msg,
          senderName: data.username,
          userType: props.externalChatData
            ? props.externalChatData.chat_type
            : "",
          chatdetails: props.externalChatData ? props.externalChatData : "",
        });
        const msgs = [...props.message];
        let newMessage3 = {
          fromSelf: true,
          message: msg,
          session_id: props.externalChatData
            ? props.externalChatData.chat_session_id
            : "",
          senderName: data.username,
          receiverName: props.externalChatData
            ? props.externalChatData.username
            : "",
          to: props.externalChatData ? props.externalChatData.id : "",
          sender: data.id,
          time: moment().format("lll"),
          msg_sent_type: msg_type,
          file_name: fileNameForDoc,
          captions: "",
        };

        // Translate if translation is active
        if (props.translationLanguage) {
          newMessage3 = await translateSingleMessage(
            newMessage3,
            props.fromLanguage,
            props.translationLanguage
          );
        }

        msgs.push(newMessage3);
        props.setMessage(msgs);
        playMsgTone();
      }
    } catch (error) {
      console.log("handleSendMsg", error);
      toast.error("Internet connection is lost!", toaststyle);
    }
  };
  const getCurrentChatMessage = async () => {
    if (!props.chatSessionId) return;
    props.setChatSpinner(true);
    await axios
      .post(
        BaseUrl + "/message/getCurrentChatMessage",
        {
          limit: 10000, //10 data
          offset: 0, //page
          sessionId: props.chatSessionId
            ? props.chatSessionId
            : JSON.parse(localStorage.getItem("client")),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if ((selectedChat ? selectedChat.chat_type : "") == "internal") {
            let sender_id = props.internalChatData
              ? props.internalChatData.senderDetails[0]._id
              : "";
            let current_agent_id = datas ? datas.id : "";

            if (sender_id != current_agent_id) {
              if (response.data.data) {
                props.setChatSpinner(false);
                props.setMessage(response.data.data);
                // props.setChatSessionId("");
              } else {
                props.setChatSpinner(false);
                props.setMessage([]);
                // props.setChatSessionId("");
              }
            } else {
              if (response.data.data) {
                props.setChatSpinner(false);
                props.setMessage(response.data.data);
                // props.setChatSessionId("");
              } else {
                props.setChatSpinner(false);
                props.setMessage([]);
                // props.setChatSessionId("");
              }
            }
          } else {
            // console.log("messsssage", response.data.data);
            props.setChatSpinner(false);
            props.setMessage(response.data.data);
            // props.setChatSessionId("");
          }
        } else {
          props.setChatSpinner(false);
          props.setMessage([]);
          // props.setChatSessionId("");
        }
      })
      .catch((err) => {
        console.log("err", err);
        props.setChatSpinner(false);
        props.setMessage([]);
        // props.setChatSessionId("");
      });
  };
  const getVoiceChatMessage = async () => {
    if (!props.chatSessionId) return;
    props.setChatSpinner(true);
    await axios
      .post(
        BaseUrl + "/message/listmessagepagination",
        {
          messager_id: props.externalChatData.unique_id.id,
          limit: 10000, //10 data
          offset: 0, //page
          agent: props.externalChatData.agent,
          sessionId: props.chatSessionId
            ? props.chatSessionId
            : JSON.parse(localStorage.getItem("client")),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if ((selectedChat ? selectedChat.chat_type : "") == "internal") {
            let sender_id = props.internalChatData
              ? props.internalChatData.senderDetails[0]._id
              : "";
            let current_agent_id = datas ? datas.id : "";

            if (sender_id != current_agent_id) {
              if (response.data.data) {
                props.setChatSpinner(false);
                props.setMessage(response.data.data);
                // props.setChatSessionId("");
              } else {
                props.setChatSpinner(false);
                props.setMessage([]);
                // props.setChatSessionId("");
              }
            } else {
              if (response.data.data) {
                props.setChatSpinner(false);
                props.setMessage(response.data.data);
                // props.setChatSessionId("");
              } else {
                props.setChatSpinner(false);
                props.setMessage([]);
                // props.setChatSessionId("");
              }
            }
          } else {
            // console.log("messsssage", response.data.data);
            props.setChatSpinner(false);
            props.setMessage(response.data.data);
            // props.setChatSessionId("");
          }
        } else {
          props.setChatSpinner(false);
          props.setMessage([]);
          // props.setChatSessionId("");
        }
      })
      .catch((err) => {
        console.log("err", err);
        props.setChatSpinner(false);
        props.setMessage([]);
        // props.setChatSessionId("");
      });
  };
  useEffect(() => {
    const handleArrivalMessage = async () => {
      if (props.arrivalMessage) {
        if (
          (selectedChat ? selectedChat.chat_session_id : "") ==
          props.arrivalMessage.session_id
        ) {
          let messageToAdd = props.arrivalMessage;

          // Translate if translation is active
          if (props.translationLanguage) {
            messageToAdd = await translateSingleMessage(
              props.arrivalMessage,
              props.fromLanguage,
              props.translationLanguage
            );
          }

          props.setMessage([...props.message, messageToAdd]);
          props.setArrivalMessage(null);
        }
      }
    };

    handleArrivalMessage();
  }, [props.arrivalMessage]);

  useEffect(() => {
    if (conversationBodyRef.current) {
      setTimeout(() => {
        const { scrollHeight, clientHeight } = conversationBodyRef.current;
        conversationBodyRef.current.scrollTop = scrollHeight - clientHeight;
      }, 100); 
    }
  }, [props.message, props.customerTyping, props.arrivalMessage]);

  useEffect(() => {
    if (
      (props.externalChatData ? props.externalChatData.channel : "") === "email"
    ) {
      props.fetchEmail();
    } else if (
      (props.externalChatData ? props.externalChatData.channel : "") === "voice"
    ) {
      getVoiceChatMessage();
    } else {
      getCurrentChatMessage();
    }
  }, [props.chatSessionId]);

  return (
    <Box
      sx={{
        height: "100%",
        width: "calc(100% - 229px)",
      }}
    >
      <Stack
        sx={{ height: "100%", width: "100%" }}
        direction={"row"}
        spacing={0.5}
      >
        {(() => {
          switch (value) {
            case 2:
              switch (
                props.externalChatData ? props.externalChatData.channel : ""
              ) {
                case "from_purple":
                  return (
                    <iframe
                      src={props.externalChatData.transcripturl}
                      width="100%"
                      height="100%"
                    />
                  );
                default:
                  return (
                    <div
                      className="cont-details-main"
                      style={{
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        userSelect: "none",
                      }}
                    >
                      <Stack
                        alignItems={"center"}
                        justifyContent={"center"}
                        spacing={2}
                        sx={{ height: "100%", width: "100%" }}
                      >
                        <img
                          src={NoSelectContact}
                          alt="pic"
                          style={{ width: "25rem" }}
                        />
                        <h4
                          style={{
                            color: "#3BA0E1",
                            fontWeight: "600",
                            userSelect: "none",
                            fontSize: "13px",
                          }}
                        >
                          No interactions were found. Please select any
                          interaction.
                        </h4>
                      </Stack>
                    </div>
                  );
              }
            case 1:
              switch (
                props.internalChatData ? props.internalChatData.chat_type : ""
              ) {
                case "internal":
                  return (
                    <Box
                      sx={{
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <Stack
                        spacing={0.5}
                        sx={{ width: "100%", height: "100%" }}
                      >
                        <InternalConversationHeader />
                        <Box
                          ref={conversationBodyRef}
                          sx={{
                            flexGrow: 1,
                            background: `url(${chatbackgroundImg})`,
                            borderRadius: 0.9,
                            boxShadow:
                              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                            overflowY: "scroll",
                            overflowX: "none",
                            scrollBehavior: "smooth",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "top center",
                            height: "100vh",
                          }}
                          p={2}
                          className="m-0"
                        >
                          <ConversationBodyInternal menu={false} />
                        </Box>
                        <CoversationFooterInternal
                          ShowVoice={false}
                          handleTyping={handleTyping}
                          handleSendMsg={handleSendMsg}
                        />
                      </Stack>
                    </Box>
                  );
                default:
                  return (
                    <div
                      className="cont-details-main"
                      style={{
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        userSelect: "none",
                      }}
                    >
                      <Stack
                        alignItems={"center"}
                        justifyContent={"center"}
                        spacing={2}
                        sx={{ height: "100%", width: "100%" }}
                      >
                        <img
                          src={NoSelectContact}
                          alt="pic"
                          style={{ width: "25rem", userSelect: "none" }}
                        />
                        <h4
                          style={{
                            color: "#3BA0E1",
                            fontWeight: "600",
                            userSelect: "none",
                            fontSize: "13px",
                          }}
                        >
                          No interactions were found. Please select any
                          interaction.
                        </h4>
                      </Stack>
                    </div>
                  );
              }
            case 0:
              switch (
                props.externalChatData ? props.externalChatData.channel : ""
              ) {
                case "email":
                  return (
                    <>
                      <Box
                        sx={{
                          height: "100%",
                          width: props.userlistshow ? "50vw" : "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          background: "#FFFF",
                          overflow: "hidden",
                        }}
                      >
                        <EmailConversationHeader noHeaderAction={true} />

                        {props.showEmailList ? (
                          <Box
                            ref={contentRef}
                            sx={{
                              overflowY: "scroll",
                              height: "calc(100% - 55px)",
                              gap: "5px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                            p={1}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                height: "max-content",
                                boxShadow:
                                  "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
                              }}
                              p={1}
                            >
                              <Typography
                                variant="caption2"
                                sx={{ maxWidth: "300px" }}
                                noWrap
                              >
                                <h6
                                  style={{
                                    fontSize: "12px",
                                    marginBottom: "0",
                                    fontWeight: 600,
                                  }}
                                >
                                  {props.externalChatData
                                    ? props.externalChatData.email_subject.split(
                                        "]"
                                      )[1]
                                    : "NA"}
                                </h6>
                              </Typography>
                            </Box>

                            {props.mailList.length > 0 ? (
                              props.mailList.map((mail) => {
                                return (
                                  <EmailBody
                                    key={mail.Email._id}
                                    mail={mail}
                                    handleChange={handleChange}
                                    expanded={expanded}
                                    preview={false}
                                    action={true}
                                  />
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </Box>
                        ) : (
                          <Box
                            ref={contentRef}
                            sx={{
                              overflowY: "scroll",
                              height: "calc(100% - 55px)",
                            }}
                            p={1}
                          >
                            <SendMailComponent />
                          </Box>
                        )}
                      </Box>
                      {props.userlistshow && <UserListComponent />}
                    </>
                  );
                case "videochat":
                case "Konnect":
                  return (
                    <>
                      <Box
                        sx={{
                          height: "100%",
                          width: props.userlistshow ? "50vw" : "100%",
                          boxShadow:
                            "rgb(207, 209, 214) 0px 8px 8px, rgb(200 200 200) 0px 0px 6px",
                        }}
                      >
                        <Stack
                          spacing={0.5}
                          sx={{ width: "100%", height: "100%" }}
                        >
                          <VideoChatConversationHeader />

                          <Box
                            className="CONTACT-LIST-AREA"
                            sx={{
                              flexGrow: 1,
                              backgroundColor: "#FFFF",
                              borderRadius: 0.9,
                              boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
                              overflowY: "scroll",
                            }}
                            p={1}
                          >
                            <iframe
                              src={props.externalChatData.leader_link}
                              title="My iframe"
                              width="100%" // Adjust the width and height as needed
                              height="100%"
                              frameBorder="0" // Remove iframe border if not needed
                              allowFullScreen // Add this attribute if you want to allow full-screen mode
                              allow="camera; microphone"
                            ></iframe>
                          </Box>
                        </Stack>
                      </Box>
                      {props.userlistshow && <UserListComponent />}
                    </>
                  );
                case "voice":
                  return (
                    <>
                      <UserListComponent2 />
                      {props.userlistshow && (
                        <Box
                          sx={{
                            height: "100%",
                            width: "calc(100% - 50vw)",
                          }}
                        >
                          <Stack sx={{ width: "100%", height: "100%" }}>
                            <VoiceConversationHeader
                              stopwatch1={stopwatch1}
                              stopwatch2={stopwatch2}
                              aesSocket={aesSocket}
                            />
                            <Box
                              className="CONTACT-LIST-AREA mt-0"
                              ref={conversationBodyRef}
                              sx={{
                                flexGrow: 1,
                                backgroundColor: "white",
                                background: `url(${chatbackgroundImg})`,
                                borderRadius: "0 0 0 0",
                                boxShadow:
                                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                                overflowY: "scroll",
                                scrollBehavior: "smooth",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "top center",
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                              }}
                              p={2}
                            >
                              {/* No chat image star*/}
                              <Stack
                                className="mt-3"
                                alignItems={"center"}
                                justifyContent={"center"}
                                sx={{
                                  position: "fixed",
                                  width: "306px",
                                  height: "351px",
                                }}
                              >
                                <Box>
                                  <img
                                    src={nochatImg}
                                    alt=""
                                    srcset=""
                                    width={"270px"}
                                    height={"auto"}
                                  />
                                </Box>
                                <Box>
                                  <p className="fs-13 fw-bold textp p-3">
                                    It looks like there are no previous chats
                                    available to load.
                                  </p>
                                </Box>
                              </Stack>
                              {/* No chat image End */}
                              {/* Voice call chat start  */}
                              <ConversationBodyExternal menu={false} />
                              {/* Voice call chat start  */}
                            </Box>
                          </Stack>
                        </Box>
                      )}
                    </>
                  );
                case "webchat":
                case "from_whatsapp":
                case "from_facebook":
                case "from_purple":
                case "from_google":
                  return (
                    <>
                    {!props.showChatFullScreen && (
                      <UserListComponent2 handleSendMsg={handleSendMsg} />
                    )}

                      {props.userlistshow && (
                        <Box
                          sx={{
                            height: "100%",
                            width: props.showChatFullScreen
                            ? "calc(100%)"
                            : "calc(100% - 50vw)",
                            background: "#eef7ff",
                          }}
                        >
                          <Stack
                            // spacing={0.5}
                            sx={{ width: "100%", height: "100%" }}
                          >
                            <WebChatConversationHeader
                              noHeaderAction={false}
                              handleSendMsg={handleSendMsg}
                            />
                            <Box
                              className="CONTACT-LIST-AREA"
                              ref={conversationBodyRef}
                              sx={{
                                flexGrow: 1,
                                background: `url(${chatbackgroundImg})`,
                                borderRadius: "0",
                                boxShadow:
                                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                                overflowY: "scroll",
                                scrollBehavior: "smooth",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "top center",
                                height: "100vh",
                              }}
                              p={1}
                            >
                              <ConversationBodyExternal menu={false} />
                            </Box>

                            {props.externalChatData ? (
                              props.externalChatData.is_customer_disconnected ==
                              false ? (
                                <CoversationFooterExternal
                                  handleTyping={handleTyping}
                                  handleSendMsg={handleSendMsg}
                                  ShowVoice={true}
                                />
                              ) : null
                            ) : null}
                          </Stack>
                        </Box>
                      )}
                    </>
                  );
                default:
                  return (
                    <div
                      className="cont-details-main"
                      style={{
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        userSelect: "none",
                      }}
                    >
                      <Stack
                        alignItems={"center"}
                        justifyContent={"center"}
                        spacing={2}
                        sx={{ height: "100%", width: "100%" }}
                      >
                        <img
                          src={NoSelectContact}
                          alt="pic"
                          style={{ width: "25rem" }}
                        />
                        <h4
                          style={{
                            color: "#3BA0E1",
                            fontWeight: "600",
                            userSelect: "none",
                            fontSize: "13px",
                          }}
                        >
                          No interactions were found. Please select any
                          interaction.
                        </h4>
                      </Stack>
                    </div>
                  );
              }
            default:
              return (
                <div
                  className="cont-details-main"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                    userSelect: "none",
                  }}
                >
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    spacing={2}
                    sx={{ height: "100%", width: "100%" }}
                  >
                    <img
                      src={NoSelectContact}
                      alt="pic"
                      style={{ width: "25rem", userSelect: "none" }}
                    />
                    <h4
                      style={{
                        color: "#3BA0E1",
                        fontWeight: "600",
                        userSelect: "none",
                        fontSize: "13px",
                      }}
                    >
                      No interactions were found. Please select any interaction.
                    </h4>
                  </Stack>
                </div>
              );
          }
        })()}
      </Stack>
    </Box>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
  setCustomerTyping,
  setArrivalMessage,
  setChatSessionId,
  setChatSpinner,
  updateNotification,
  updateAgentList,
  updateContactList,
  setMsgTone2,
  setEmailList,
  setShowEmailList,
  setselectedMail,
  fetchEmail,
  setMessage,
})(ChatComponent);
